module.exports = __webpack_public_path__ + "static/media/geotechnical_investigation_see_far2.e5a04359.jpeg";